export const PROXY_URL = "https://ess-ml-dashboard.herokuapp.com";
// export const PROXY_URL = "http://localhost:5000";


// WEBPACK FOOTER //
// ./src/component/misc/ProxyURL.js